import { render, staticRenderFns } from "./Alias.vue?vue&type=template&id=688083f3&"
import script from "./Alias.vue?vue&type=script&lang=js&"
export * from "./Alias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports